import axiosCall from './interceptor';
import URL from '../helper';

export const saveElement = async payload => {
  const url = `${URL.BASE_URL}element`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteFlowElement = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/flow?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const deleteBlockElement = async id => {
  const url = `${URL.DESIGN_SYSTEM_URL}standalone/block?id=${id}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

export const getAllRefElements = async (page, referenced, categoryIds, name, tags,rgpermission) => {
  let payload = {
    page,
    referenced
  };
  if (categoryIds) payload.categoryIds = categoryIds;
  if (name) {
    payload.name = name;
  }
  if (tags) {
    payload.tags = tags;
  }
  if (rgpermission) {
    payload.rgpermission = rgpermission;
  }

  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}element?limit=8&${searchParam.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllFlowByCategories = async () => {
  const url = `${
    URL.DESIGN_SYSTEM_URL
  }standalone/flowByCategory`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllBlockByCategories = async () => {
  const url = `${
    URL.DESIGN_SYSTEM_URL
  }standalone/blockByCategory`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const getAllCategoryElements = async (
  includePages = false,
  referenced,
  rgpermission,
  isMaterElement,
) => {
  const url = `${
    URL.BASE_URL
  }elementbycategory?includePages=${includePages}&referenced=${referenced}&from=${
    isMaterElement ? 'master' : 'user'
  }${rgpermission ? `&rgpermission=${rgpermission}` : ''}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllFlowElements = async (page, referenced, categoryIds, name, tags,rgpermission, forApproval, v2 = false, additionalPayload = {}) => {
  let params = {
    page: page,
    limit: 8,
    rgPermission: rgpermission,
  };
  if(categoryIds) {
    params.categoryIds = categoryIds;
  }
  if(name) {
    params.name = name;
  }
  if(tags) {
    params.tags = tags;
  }
  if(forApproval) {
    params.qaReadyStatus = 'qacomplete';
  }
  if(v2) {
    params = Object.assign({}, params, additionalPayload);
  }
  const uriComponent = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
  let url = `${URL.DESIGN_SYSTEM_URL}standalone/flow?${uriComponent}`;
  if(forApproval) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyFlow?${uriComponent}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
}

export const getAllBlockElements = async (page, referenced, categoryIds, name, tags,rgpermission, forApproval, v2 = false, additionalPayload = {}, limit = 8) => {
  let params = {
    page: page,
    limit: limit,
    rgPermission: rgpermission,
  };
  if(forApproval) {
    params.qaReadyStatus = 'qacomplete';
  }
  if(categoryIds) {
    params.categoryIds = categoryIds;
  }
  if(name) {
    params.name = name;
  }
  if(tags) {
    params.tags = tags;
  }
  if(v2) {
    params = Object.assign({}, params, additionalPayload);
  }
  const uriComponent = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
  let url = `${URL.DESIGN_SYSTEM_URL}standalone/block?${uriComponent}`;
  if(forApproval) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyBlock?${uriComponent}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
}

///////mailElements /////

export const getAllEmailElement = async (
  page,
  referenced,
  listOfCategoryId,
  elementName,
  tags,
  accessType = '',
) => {
  let payload = {
    page,
    referenced,
  };
  if (accessType) payload.accessType = accessType;
  if (elementName) {
    payload.elementName = elementName;
  }
  if (tags) {
    payload.tags = tags;
  }
  if (listOfCategoryId) {
    payload.listOfCategoryId = listOfCategoryId;
  }

  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}getAllEmailElement?limit=8&${searchParam.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
};
export const getEmailElementCateg = async referenced => {
  const url = `${URL.BASE_URL}getAllEmailElement?groupByCategory=true&accessType=write&referenced=${referenced}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const deleteEmailElement = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}deleteElement?${params}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const validateDocElementName = async (payload) => {
  const url = `${URL.BASE_URL}element/nameexist?name=${payload.name}&referenced=${payload.referenced}`;
  const response = await axiosCall('get', url, false);
  return response.data;
};

export const getLanguageGroupedFlows = async (
  page,
  referenced,
  categoryIds,
  name,
  tags,
  rgpermission,
  forApproval,
  v2 = false,
  additionalPayload = {},
) => {
  let params = {
    page: page,
    limit: 8,
    rgPermission: rgpermission,
  };
  if (categoryIds) {
    params.categoryIds = categoryIds;
  }
  if (name) {
    params.name = name;
  }
  if (tags) {
    params.tags = tags;
  }
  if (v2) {
    params = Object.assign({}, params, additionalPayload);
  }
  const uriComponent = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  let url = `${URL.DESIGN_SYSTEM_URL}standalone/draft/flows?${uriComponent}`;
  if (forApproval) {
    url = `${URL.TRANSACTION_SYSTEM_URL}standalone/qaFlows?${uriComponent}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};

export const getLanguageGroupedBlocks = async (
  page,
  referenced,
  categoryIds,
  name,
  tags,
  rgpermission,
  forApproval,
  v2 = false,
  additionalPayload = {},
  limit = 8,
) => {
  let params = {
    page: page,
    limit: limit,
    rgPermission: rgpermission,
  };
  if (categoryIds) {
    params.categoryIds = categoryIds;
  }
  if (name) {
    params.name = name;
  }
  if (tags) {
    params.tags = tags;
  }
  if (v2) {
    params = Object.assign({}, params, additionalPayload);
  }
  const uriComponent = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  let url = `${URL.DESIGN_SYSTEM_URL}standalone/draft/blocks?${uriComponent}`;
  if (forApproval) {
    url = `${URL.TRANSACTION_SYSTEM_URL}standalone/qaBlocks?${uriComponent}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};